import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Typography,
  TextField,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
//import couponPercentIcon from "../../../../assets/coupon-percent.png";
import { ErrorRounded as ErrorRoundedIcon } from "@mui/icons-material";
import "./CouponCodeDialog.scss";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../../utils/localization";
const CouponCodeDialog: React.FC<any> = ({
  open,
  onClose,
  allActiveCoupons,
  setCouponCodeData,
  checkValidityOfcoupon,
  couponApplyResponse,
  couponCodeType
}) => {
   const { t, i18n } = useTranslation();
  const [couponCode, setCouponCode] = useState<string>("");

  const handleApplyCoupon = (couponCodeSelected: string) => {
    setCouponCode(couponCodeSelected);
    setCouponCodeData(couponCodeSelected);
    checkValidityOfcoupon(couponCodeSelected);
  };

  const handleRemoveCoupon = () => {};

  const applyCouponCode = () => {
    console.log("Coupon code", couponCode);
    // handleSetCouponApplyResponse();
    // onClose();
    checkValidityOfcoupon(couponCode);
  };

 const [couponList,setCouponList] = useState<any>([])

  useEffect(() => {
    
   if(allActiveCoupons?.length > 0){
    const filterType = ["ALL",couponCodeType] 
    const  newCouponList = allActiveCoupons?.filter((el:any) =>  filterType.includes(el.couponType)) 
    setCouponList(newCouponList)
    setCouponCode(newCouponList[0]?.couponCode)
   }

  }, [allActiveCoupons])

  return (
    <Dialog open={open} onClose={onClose}>
      {/* <DialogTitle>Apply Coupon</DialogTitle> */}
      <DialogTitle sx={{ m: 0, p: 2 }}>{t(LOCALIZATION.Apply_Coupon)}</DialogTitle>
      <Button
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 2,
          top: 13,
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}
      >
        <CloseIcon />
      </Button>
      <Divider /> {/* Divider added here */}
      <DialogContent sx={{ width: { lg: "600px", md: "600px", xs: "310px" } }}>
        <TextField
          label= {t(LOCALIZATION.Code)}
          variant="outlined"
          fullWidth
          value={couponCode}
          sx={{ mb: 1 }} // Margin-bottom for spacing
          onChange={(e: any) => setCouponCode(e.target.value)}
        />
        {couponApplyResponse.isError ? (
          <Box className="CouponNotValidText">
            <Typography>
              <ErrorRoundedIcon />
             {t(LOCALIZATION.Coupon_Code_Is_Not_Valid)}
            </Typography>
          </Box>
        ) : null}

        {/* {couponCode && (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
            className="couponCodeDialogTop"
          >
            <Box className="couponApplySec">
              <img src={couponApplyIcon} alt="" />
              <Box>
                <Typography className="couponText">
                  Devotee(s) saved <span>₹{couponApplyResponse?.discount}</span> with
                  coupon code {""}
                  <span>{couponCode}</span>
                </Typography>
              </Box>
            </Box>
            <Box className="removeBtn">
              <Button variant="text" onClick={handleRemoveCoupon}>
                Remove
              </Button>
            </Box>
          </Stack>
        )} */}

        <Box className="applyBtn">
          <Button
            variant="contained"
            onClick={(e: any) => applyCouponCode()}
            sx={{ width: "90%", borderRadius: "25px" }}
          >
            {t(LOCALIZATION.Apply_Coupon)}
          </Button>
        </Box>

        <Box className="existingCouponCode">
          <Typography className="existingCodeTitle">
          {t(LOCALIZATION.Existing_Coupons)}
          </Typography>
          <List className="existingCodeList">
            {couponList?.map((item: any, id: any) => (
              <ListItem
                key={id}
                sx={{ borderBottom: "1px solid #ccc", p: "8px 10px" }}
              >
                <ListItemText
                  className="codeText"
                  primary={`${item?.couponCode}`}
                />
                <ListItemSecondaryAction>
                  <Button
                    variant="text"
                    color="success"
                    className="existingCodeApplyBtn"
                    onClick={() => handleApplyCoupon(item?.couponCode)}
                  >
                    <Typography>{t(LOCALIZATION.Apply)}</Typography>
                  </Button>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default CouponCodeDialog;
